import React from "react";

import {
  Img,
  Button,
  GridContainer,
  GridRow,
  GridColumn,
  Utils,
} from "arv-reactcomponents";

import { Header } from "arv-extends";

const { wrapper, getFinalComponent } = Header.MobileHeader.NnnowBar;
const NavContainer = Header.MobileHeader.NavContainer;
const { MyBagActionButton, SearchActionButton } = Header.ActionButtons;

class NnnowBarComponent extends wrapper {
  constructor(props) {
    super(props);
    this.state = {
      hideMenu: true,
    };
    this.onMenuClick = this.onMenuClick.bind(this);
    this.hideWhenSearch = this.hideWhenSearch.bind(this);
  }

  render() {
    const data =
      (this.props.NavListStore &&
        this.props.NavListStore.navListData &&
        this.props.NavListStore.navListData.data &&
        this.props.NavListStore.navListData.data.menu &&
        this.props.NavListStore.navListData.data.menu.level1) ||
      [];

    return (
      <GridContainer className="nw-brandbar-wrapper">
        <GridRow className="nw-brandbar-row">
          <GridColumn className="wc-nnnowbar-menu">
            <Button
              onClick={this.onMenuClick}
              className={`nw-brandbar-action-button nw-brandbar-menu  ${
                this.hideIfBrandpageClassName
              } ${this.menuActiveClass}`}
            >
              <i className="icomoon-menu" />
            </Button>
          </GridColumn>
          <GridColumn className="nw-nnnowbar-logo" title="Wildcraft Home">
            <a href="/" target="_self" onClick={NnnowBarComponent.onLogoClick}>
              <Img
                className={`nw-nnnowbar-logoimg ${
                  this.hideIfBrandpageClassName
                }`}
                src={this.logoUrl}
              />
            </a>
          </GridColumn>
          <GridColumn className="nw-brandbar-actions">
            <div
              className="nw-nnnowbar-searchwrap"
              onKeyDown={Utils.noop}
              role="presentation"
              onClick={this.hideWhenSearch}
            >
              <SearchActionButton.component />
            </div>
            <MyBagActionButton.component />
          </GridColumn>
          <GridColumn className="nw-nnnowbar-nav">
            <nav
              className={`nw-brandbar-hamburger-menu nw-brandbar-nnnow-menu ${
                this.menuActiveClass
              } ${this.hideMenuClass}`}
            >
              <NavContainer.component
                className="nw-nnnow-header"
                navData={data}
                reset={this.hideWhenSearch}
              />
            </nav>
          </GridColumn>
        </GridRow>
      </GridContainer>
    );
  }
}

Header.MobileHeader.NnnowBar.component = getFinalComponent(NnnowBarComponent);
